import React from 'react';

/** Phosphor `ph-call-bell` — Sidebar "Pre-Paid Requests". */
const PhCallBellSvg = ({ size = 18 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 256 256" fill="currentColor" aria-hidden>
    <path d="M24,184a8,8,0,0,1,8-8H40V160a88.13,88.13,0,0,1,80-87.63V56H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16H136V72.37A88.13,88.13,0,0,1,216,160v16h8a8,8,0,0,1,0,16H32A8,8,0,0,1,24,184Zm32-8H200V160a72,72,0,0,0-144,0Z" />
  </svg>
);

export default PhCallBellSvg;
